import { themeColors } from '@/theme/colors';

type Props = {
  isOn: boolean;
  onLabel: string;
  offLabel: string;
};

/** A small green (on) or red (off) dot. */
export const StatusDot = ({ isOn, onLabel, offLabel }: Props) => {
  const label = isOn ? onLabel : offLabel;
  return (
    <span
      role="img"
      aria-label={label}
      title={label}
      style={{
        display: 'inline-block',
        width: 10,
        height: 10,
        borderRadius: '50%',
        backgroundColor: isOn
          ? themeColors.support.positive.default
          : themeColors.support.negative.default,
      }}
    />
  );
};
